<template>
  <div class="panier-component mt-15">
    <div class="has-background-white  columns">
      <div class="column is-narrow column-img ml-40">
        <img v-if="reseau.urlPhoto" class="image tailleImage"
            :src="reseau.urlPhoto">
        <img v-else class="image tailleImage" src="@/assets/default-placeholder.png"/>
        <div class="control mb-5px">
          <label class="subtitle">Nom du réseau</label>
          <input class="input column is-10"
                  v-model="reseau.libelle"
                  type="search"
                  :disabled="disabled"/>
        </div>
        <p class="information">Nb produit :
          {{reseau.nbProduits}}
        </p>
        <p class="information">Nb de faces :
          {{reseau.nbFaces}}
        </p>
      </div>
      <div class="column columns">
        <div class="column pt-0 pr-0 is-8 columns is-multiline is-marginless">
          <div class="column is-4 p-5px">
            <b-field grouped>
              <b-field label="Tarif Brut HT" class="mb-0" custom-class="mb-0 label-color" expanded>
                <input-currency
                  v-model="reseau.tarifHT"
                  isNumber="true"
                  :disabled="disabled"/>
              </b-field>
            </b-field>
          </div>
          <div class="column is-4 p-5px">
              <b-field label="Remise" class="mb-0" custom-class="mb-0 label-color">
                <b-field>
                  <input-currency
                    v-model="reseau.remise"
                    isNumber="true"
                    :disabled="disabled"/>
                  <b-select v-model="reseau.typeDeRemise" placeholder="0">
                    <option :value="0">%-</option>
                    <option :value="1">€</option>
                  </b-select>
                </b-field>
              </b-field>
          </div>
          <div class="column is-4 p-5px">
            <b-field label="Tarif Net HT" class="mb-0" custom-class="mb-0 label-color" expanded>
              <input-currency
                :value="tarifNet"
                isNumber="true"
                :disabled="disabled"
                @input="changeTarifNet">
              </input-currency>
            </b-field>
          </div>
          <div class="column is-6 p-5px">
            <div class="control">
              <label class="subtitle">Tarif de pose HT</label>
              <input-currency
                v-model="reseau.tarifDePose" isNumber="true"
                :disabled="disabled">
              </input-currency>
            </div>
          </div>
          <div class="column is-6 p-5px">
            <div class="control">
              <label class="subtitle">Tarif d'impression HT</label>
              <input-currency
                v-model="reseau.tarifImpression"
                :disabled="disabled">
              </input-currency>
            </div>
          </div>
          <div class="column is-6 p-5px">
            <div class="control">
              <label class="subtitle">Taxes municipales / TLPE</label>
              <input-currency
                v-model="reseau.taxeMunicipale"
                :disabled="disabled">
              </input-currency>
            </div>
            Montant TLPE pour la durée de location
          </div>
          <div class="column is-6 p-5px">
          </div>
          <div class="column is-6 p-5px">
            <div class="control">
              <label class="subtitle">Du</label>
              <b-datepicker
                icon="calendar-today"
                :readonly="false"
                :disabled="disabled"
                v-model="reseau.dateDebut"/>
            </div>
          </div>
          <div class="column is-6 p-5px">
            <div class="control">
              <label class="subtitle">Au</label>
              <b-datepicker
                icon="calendar-today"
                :readonly="false"
                v-model="reseau.dateFin"
                :disabled="disabled"/>
            </div>
          </div>
        </div>
        <div class="column pt-0 pl-0 is-marginless is-one-third">
          <div class="column is-12 p-5px">
            <b-field label="Commentaire" custom-class="mb-0 label-color">
              <b-input
                v-model="reseau.commentaire"
                type="textarea"/>
          </b-field>
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="column is-12 p-5px">
          <article class="media">
            <div class="media-left">
              <b-dropdown position="is-bottom-left"
                          :disabled="disabled">
                <button slot="trigger" class="button"
                  :style="{ 'background-color':reseau.couleur }">
                  <b-icon icon="map-marker" style="color: white"></b-icon>
                </button>
                <b-dropdown-item :ref="refDropDown+reseau.num">
                  <color-picker :props="reseau" :couleur="reseau.couleur"
                                @colorsPickerChange="colorsPickerChange">
                  </color-picker>
                </b-dropdown-item>
              </b-dropdown>
            </div>
            <div class="media-content mt-8 -paddingless">
              <div class="content has-text-weight-semibold">
                Couleur
              </div>
            </div>
          </article>
        </div>
        <div class="column is-12 p-5px">
          <article class="media">
            <div class="media-left">
              <button class="button is-primary" @click="ouvrirDiaporama()">
                <b-icon icon="image-multiple"></b-icon>
              </button>
            </div>
            <div class="media-content mt-8 -paddingless">
              <div class="content has-text-weight-semibold">
                Diaporama
              </div>
            </div>
          </article>
        </div>
        <div class="column is-12 has-background-color-background">
          <span class="mb-0 label-color has-text-weight-bold">Editions</span>
          <div class="column is-12 p-5px">
            <article class="media media-align-center">
              <div class="media-left">
                <button
                  class="button"
                  v-bind:class="[reseau.masquerRemiseEdition ?
                    'is-primary' : 'is-grey']"
                  @click.prevent="$refs.checkBoxMasquerRemiseEdition.click()">
                  <b-icon
                    icon="percent"
                    :type="reseau.masquerRemiseEdition ?
                      'is-white' : 'is-grey'"></b-icon>
                </button>
              </div>
              <div class="media-content is-paddingless">
                <div class="content has-text-weight-semibold is-inline">
                  Afficher la remise sur l’édition
                </div>
                <input
                  type="checkbox"
                  v-model="reseau.masquerRemiseEdition"
                  :disabled="disabled"
                  id="checkbox"
                  class="is-invisible is-inline"
                  ref="checkBoxMasquerRemiseEdition">
              </div>
            </article>
          </div>
          <div class="column is-12 p-5px">
            <article class="media">
              <div class="media-left">
                <button
                  class="button"
                  v-bind:class="[reseau.masquerFaceEdition ?
                  'is-primary' : 'is-grey']"
                  @click="reseau.masquerFaceEdition =
                  !reseau.masquerFaceEdition">
                  <b-icon
                    icon="eye-off" :type="reseau.masquerFaceEdition ? 'is-white' : 'is-grey'"/>
                </button>
              </div>
              <div class="media-content is-paddingless">
                <div class="content has-text-weight-semibold">
                  Masquer les faces sur l'édition
                </div>
              </div>
            </article>
          </div>
          <div class="column is-12 p-5px">
            <article class="media">
              <div class="media-left">
                <button
                  class="button"
                  :class="reseau.visualiserCarteEdition ?
                  'is-primary' : 'is-grey'"
                  @click.prevent="$refs.checkBoxVisuCartoReseauPerso.click()">
                  <b-icon icon="google-maps"/>
                </button>
              </div>
              <div class="media-content is-paddingless">
                <div class="content has-text-weight-semibold">
                  Afficher la cartographie
                </div>
                <input
                  type="checkbox"
                  v-model="reseau.visualiserCarteEdition"
                  :disabled="disabled"
                  id="checkbox"
                  class="is-invisible"
                  ref="checkBoxVisuCartoReseauPerso">
              </div>
            </article>
          </div>
        </div>
      </div>
      <div class="column is-1 is-paddingless mr-20">
        <div class="is-flex flex-align-center-justify-end p-5px">
          <p class="has-text-weight-bold is-size-6 has-text-black mr-12">
            {{reseau.prixTotal}} €
          </p>
          <a @click="suppressionPanneau">
            <b-icon icon="delete-forever" type="is-danger"/>
          </a>
        </div>
      </div>
    </div>
    <b-collapse class="has-background-white card-informations">
      <div slot="trigger" class="card-header" @click="isOpen = !isOpen">
        <a class="card-header-icon">
          <b-icon
            :icon="isOpen ? 'chevron-down' : 'chevron-up'">
          </b-icon>
          <span class="texte-collapse">Produits ({{reseau.produits.length}})</span>
        </a>
      </div>
      <div>
        <v-client-table :data="reseau.produits"
                        :columns="columns"
                        :options="options">
          <div slot="nom"
               slot-scope="props">
            <div v-if="props.row.annee && props.row.semaine">
              {{props.row.nom}} - Semaine {{props.row.semaine}} - {{props.row.annee}}
            </div>
            <div v-else>
              {{props.row.nom}}
            </div>
          </div>

          <div slot="action" slot-scope="props" style="text-align:center">
            <a @click="linkOff(props.row)">
              <b-icon icon="link-off" type="is-default"></b-icon>
            </a>
          </div>
        </v-client-table>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as types from '@/store/creationOpportunite/panier-mutation-type';
import * as typesModal from '@/store/creationOpportunite/modal-mutation-type';
import inputCurrency from '@/components/general/inputCurrency';
import colorPicker from '@/components/general/colorPicker';
import gestionErreur from '@/services/general/gestionErreur';
import arrondiResult from '@/services/general/arrondiCalcul';
import getFacesReseauPerso from '@/services/panier/getFacesReseauPerso';
import { columnsSplice } from '@/services/general/columns';

const Panier = createNamespacedHelpers('panier');
const Modal = createNamespacedHelpers('modal');
const user = createNamespacedHelpers('user');

export default {
  name: 'reseaux-personnalise-lc',
  props: ['reseau', 'disabled'],
  data() {
    return {
      refDropDown: 'refDropDown',
      isOpen: true,
      trad: {
        nbFaces: ' Nombre de faces',
        ville: 'Ville',
        type: 'Type',
        nom: 'Nom',
        action: '',
      },
      inputTarifNet: this.reseau.tarifNet,
    };
  },
  components: {
    inputCurrency,
    colorPicker,
  },
  watch: {
    tarifNet: {
      handler(val) {
        this.reseau.tarifNet = val;
      },
      immediate: true,
    },
  },
  computed: {
    ...Panier.mapGetters({
      getPanier: 'panier',
    }),
    ...user.mapGetters({
      isAffichageFaceEditionDefault: 'isAffichageFaceEditionDefault',
    }),
    panier: {
      get() {
        return this.getPanier;
      },
      set(value) {
        this.setPanier(value);
      },
    },
    ...Modal.mapGetters({
      getIsComponentDiaporama: 'isComponentDiaporama',
      getFacesReseauSelect: 'facesSelectDiapo',
    }),
    facesReseauSelectDiapo: {
      get() {
        return this.getFacesReseauSelect;
      },
      set(value) {
        this.setFacesReseauSelect(value);
      },
    },
    isComponentDiaporama: {
      get() {
        return this.getIsComponentDiaporama;
      },
      set(value) {
        this.setIsComponentDiaporama(value);
      },
    },
    columns() {
      const columns = ['type', 'nom', 'ville', 'nbFaces', 'action'];
      if (this.disabled) columnsSplice(columns, 'action');
      return columns;
    },
    options() {
      return {
        headings: {
          type: this.trad.type,
          nom: this.trad.nom,
          ville: this.trad.ville,
          nbFaces: this.trad.nbFaces,
          action: this.trad.action,
        },
        perPage: 9999999999,
        columnsClasses: {
          adressePostaleLibelle1: 'ellipsis colonneAdresseRechercheClient',
          ville: 'ellipsis colonneVilleRechercheClient',
          telephone: 'ellipsis colonneTelephoneRechercheClient',
          voir: 'colonneVoir has-text-centered',
          nomCommercial: 'colonneNomCommercialRechercheClient',
          nomJuridique: 'ellipsis colonneNomJuridiqueRechercheClient',
          codePostal: 'codePostalRechercheClient',
          prospect: 'colonneAvecPicto_Center',
        },
        customFilters: [{
          name: 'numFilter',
          callback(row, query) {
            return row.num === query;
          },
        }],
      };
    },
    tarifNet() {
      if (!this.reseau.remise) return this.inputTarifNet;
      if (this.reseau.typeDeRemise === 0) {
        return this.reseau.tarifHT
          - this.reseau.tarifHT
          * this.reseau.remise / 100;
      }
      return this.reseau.tarifHT
      - this.reseau.remise;
    },
    prixTotal() {
      const tarifNet = this.tarifNet ? this.tarifNet : 0;
      const taxeMunicipale = this.reseau.taxeMunicipale ? this.reseau.taxeMunicipale : 0;
      const tarifDePose = this.reseau.tarifDePose ? this.reseau.tarifDePose : 0;
      const tarifImpression = this.reseau.tarifImpression ? this.reseau.tarifImpression : 0;
      return arrondiResult(tarifNet
       + taxeMunicipale
       + tarifDePose
       + tarifImpression);
    },
  },
  methods: {
    ...Panier.mapMutations({
      setPanier: types.SET_PANIER,
      setRemoveProduit: types.REMOVE_PRODUIT_TYPE_RESEAU_PERSO,
    }),
    ...Panier.mapActions({
      actionsGetFacesDeReseau: 'getFacesDeReseau',
    }),
    ...Modal.mapMutations({
      setIsComponentDiaporama: typesModal.SET_IS_COMPONENT_DIAPORAMA,
      setFacesReseauSelect: typesModal.SET_FACES_SELECT_DIAPO,
    }),
    linkOff(data) {
      const indexReseau = this.panier.produits.reseauxPersonnalise
        .map(el => el.guid).indexOf(this.reseau.guid);
      if (data.type === 'Face') {
        this.panier.produits.panneauxLc.forEach((el) => {
          if (el.extensionOpportunite.reseauPersoGuid === this.reseau.guid &&
            data.num === el.extensionOpportunite.faceSelectionne.facNum) {
            el.extensionOpportunite.reseauPersoGuid = null;
          }
        });
        const indexProduit = this.panier.produits.reseauxPersonnalise[indexReseau]
          .produits.findIndex(el => el.num === data.num && el.type === data.type);
        this.panier.produits.reseauxPersonnalise[indexReseau].produits.splice(indexProduit, 1);
        if (!this.panier.produits.reseauxPersonnalise[indexReseau].produits.length) {
          this.panier.produits.reseauxPersonnalise.splice(indexReseau, 1);
        }
      }
      if (data.type === 'Panneau numérique') {
        this.panier.produits.panneauxNumeriques.forEach((el) => {
          if (el.extensionOpportunite.reseauPersoGuid === this.reseau.guid && el.num === data.num) {
            el.extensionOpportunite.reseauPersoGuid = null;
          }
        });
        const indexProduit = this.panier.produits.reseauxPersonnalise[indexReseau]
          .produits.findIndex(el => el.num === data.num && el.type === data.type);
        this.panier.produits.reseauxPersonnalise[indexReseau].produits.splice(indexProduit, 1);
        if (!this.panier.produits.reseauxPersonnalise[indexReseau].produits.length) {
          this.panier.produits.reseauxPersonnalise.splice(indexReseau, 1);
        }
      }
      if (data.type === 'Réseau numérique') {
        this.panier.produits.reseauxNumeriques.forEach((el) => {
          if (el.extensionOpportunite.reseauPersoGuid === this.reseau.guid && el.num === data.num) {
            el.extensionOpportunite.reseauPersoGuid = null;
          }
        });
        const indexProduit = this.panier.produits.reseauxPersonnalise[indexReseau]
          .produits.findIndex(el => el.num === data.num && el.type === data.type);
        this.panier.produits.reseauxPersonnalise[indexReseau].produits.splice(indexProduit, 1);
        if (!this.panier.produits.reseauxPersonnalise[indexReseau].produits.length) {
          this.panier.produits.reseauxPersonnalise.splice(indexReseau, 1);
        }
      }
      if (data.type === 'Réseau LC') {
        this.panier.produits.reseauxLc.forEach((el) => {
          if (el.extensionOpportunite.reseauPersoGuid === this.reseau.guid && el.num === data.num) {
            el.extensionOpportunite.reseauPersoGuid = null;
          }
        });
        const indexProduit = this.panier.produits.reseauxPersonnalise[indexReseau]
          .produits.findIndex(el => el.num === data.num && el.type === data.type);
        this.panier.produits.reseauxPersonnalise[indexReseau].produits.splice(indexProduit, 1);
        if (!this.panier.produits.reseauxPersonnalise[indexReseau].produits.length) {
          this.panier.produits.reseauxPersonnalise.splice(indexReseau, 1);
        }
      }
      if (data.type === 'Réseau Temporaire') {
        this.panier.produits.reseauxTempo.forEach((el) => {
          if (el.extensionOpportunite.reseauPersoGuid === this.reseau.guid && el.num === data.num) {
            el.extensionOpportunite.reseauPersoGuid = null;
          }
        });
        const indexProduit = this.panier.produits.reseauxPersonnalise[indexReseau]
          .produits.findIndex(el => el.num === data.num && el.type === data.type);
        this.panier.produits.reseauxPersonnalise[indexReseau].produits.splice(indexProduit, 1);
        if (!this.panier.produits.reseauxPersonnalise[indexReseau].produits.length) {
          this.panier.produits.reseauxPersonnalise.splice(indexReseau, 1);
        }
      }
    },
    suppressionPanneau() {
      const panneauxLc = [];
      const reseauxTempo = [];
      const reseauxLc = [];
      const panneauxNumeriques = [];
      const reseauxNumeriques = [];
      this.panier.produits.panneauxLc.forEach((el) => {
        if (el.extensionOpportunite.reseauPersoGuid === this.reseau.guid) {
          el.extensionOpportunite.reseauPersoGuid = null;
          panneauxLc.push(el.num);
        }
      });
      this.panier.produits.reseauxTempo.forEach((el) => {
        if (el.extensionOpportunite.reseauPersoGuid === this.reseau.guid) {
          el.extensionOpportunite.reseauPersoGuid = null;
          reseauxTempo.push(el.num);
        }
      });
      this.panier.produits.reseauxLc.forEach((el) => {
        if (el.extensionOpportunite.reseauPersoGuid === this.reseau.guid) {
          el.extensionOpportunite.reseauPersoGuid = null;
          reseauxLc.push(el.num);
        }
      });
      this.panier.produits.panneauxNumeriques.forEach((el) => {
        if (el.extensionOpportunite.reseauPersoGuid === this.reseau.guid) {
          el.extensionOpportunite.reseauPersoGuid = null;
          panneauxNumeriques.push(el.num);
        }
      });
      this.panier.produits.reseauxNumeriques.forEach((el) => {
        if (el.extensionOpportunite.reseauPersoGuid === this.reseau.guid) {
          el.extensionOpportunite.reseauPersoGuid = null;
          reseauxNumeriques.push(el.num);
        }
      });
      panneauxLc.forEach(num => {
        const indexOf = this.panier.produits.panneauxLc.map(el => el.num).indexOf(num);
        this.panier.produits.panneauxLc.splice(indexOf, 1);
      });
      reseauxTempo.forEach(num => {
        const indexOf = this.panier.produits.reseauxTempo.map(el => el.num).indexOf(num);
        this.panier.produits.reseauxTempo.splice(indexOf, 1);
      });
      reseauxLc.forEach(num => {
        const indexOf = this.panier.produits.reseauxLc.map(el => el.num).indexOf(num);
        this.panier.produits.reseauxLc.splice(indexOf, 1);
      });
      panneauxNumeriques.forEach(num => {
        const indexOf = this.panier.produits.panneauxNumeriques.map(el => el.num).indexOf(num);
        this.panier.produits.panneauxNumeriques.splice(indexOf, 1);
      });
      reseauxNumeriques.forEach(num => {
        const indexOf = this.panier.produits.reseauxNumeriques.map(el => el.num).indexOf(num);
        this.panier.produits.reseauxNumeriques.splice(indexOf, 1);
      });
      this.setRemoveProduit(this.reseau);
    },
    colorsPickerChange(payload) {
      this.reseau.couleur = payload.color.hex;
    },
    async ouvrirDiaporama() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      this.facesReseauSelectDiapo = [];
      try {
        this.facesReseauSelectDiapo = await getFacesReseauPerso(this.panier, this.reseau);
        loadingComponent.close();
        this.isComponentDiaporama = true;
      } catch (e) {
        loadingComponent.close();
        gestionErreur(`Erreur lors de l'ouverture du diaporama des faces du reseau n°${this.reseau.num}`, e);
        throw e;
      }
    },
    changeTarifNet(e) {
      if (this.reseau.tarifNet !== e) {
        this.reseau.remise = 0;
        this.inputTarifNet = e;
      }
    },
  },
  mounted() {
    this.reseau.produits.sort((a, b) => {
      if (a.ville < b.ville) return -1;
      if (a.ville > b.ville) return 1;
      return 0;
    });
    if (this.reseau.masquerFaceEdition === null) {
      this.reseau.masquerFaceEdition = !this.isAffichageFaceEditionDefault;
    }
    this.reseau.typeDeRemise = 0;
  },
};
</script>

<style scoped>
  .information {
    margin-bottom: 12px;
  }

  .texte-collapse {
    font-size: 14px;
    color: #5E738B;
  }

  .card-informations {
    border: 1px #E3EAF2 solid;
    margin-left: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/panier/composantsProduits/reseauxPersonnalise.vue